import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import measurementsIcon from '#component/icon/measurements';
import { Card, StyledCardContent, CardHeaderText, CardIdentifiers, LoadingWrapper } from './styles';

function EventsMobileCard(props) {
  const {
    handleOpen,
    events,
    loading
  } = props;

  const icon = measurementsIcon('events');
  const EVENTS_TAB = 100;

  return (
    <Card>
      <StyledCardContent
        onClick={() => handleOpen(EVENTS_TAB)}
      >
        <CardIdentifiers>
          {icon}
          EVENTS
        </CardIdentifiers>
        {loading ?
          <LoadingWrapper>
            <CircularProgress size={20} />
          </LoadingWrapper> :
          <CardHeaderText>
            {[...events].length}
          </CardHeaderText> }
      </StyledCardContent>
    </Card>
  );
}

export default EventsMobileCard;
